export const PAST_DUE_DATE = {
    '00-30-days': 'past 00-30 days',
    '31-60-days': 'past 31-60 days',
    '61-90-days': 'past 61-90 days',
    'over-90-days': 'over 90 days',
    'select_all': ''
};



// WEBPACK FOOTER //
// ./src/utils/constants.tsx